<template>
  <div>
    <!-- 上半部 -->
    <div class="overview-cell">
      <!-- 有”眼睛”的行 -->
      <div>
        <span>{{ showDate }}</span>
        <div @click="changeDisplayHandler">
          <svg-icon :icon-class="imgEyePath" class-name="cur-icon"></svg-icon>
        </div>
      </div>
      <div v-for="(rows, idx) in table1" :key="idx">
        <div class="inline-cell" v-for="(item, k) in rows" :key="k" @click="$emit('clickCell', hideFlag, 'OverviewListExamine')">
          <div>
            <span>{{ item.date }}</span>
          </div>
          <div>
            <span>{{ item.name | shortText }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 下半部 -->
    <div class="overview-table" v-show="hideFlag === 'show'">
      <div v-for="(rows, idx) in table2" :key="idx">
        <div class="table-header">
          <div></div>
          <div>{{ rows.name }}</div>
        </div>
        <div class="table-bodyer" v-for="(listItem, listIdx) in rows.detail" :key="listIdx">
          <span>{{ listItem.name }}</span>
          <span>{{ listItem.count }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global
    PUBLIC_PRODUCT,
    PUBLIC_SPECIAL_MOBILE,
    PUBLIC_OVER_LABEL
*/

import { Indicator } from 'mint-ui';
import { CusToast } from '@/utils/CustomToast';
import { GetTradeCount } from '@/api/reward';
import { GetUserStatus } from '@/api/user';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';
import SvgIcon from './SvgIcon';

export default {
  name: 'OverviewListExamine',
  props: ['flag', 'actived'],
  comments: { SvgIcon },
  data() {
    return {
      hideFlag: 'hide',
      imgEyePath: 'hide_money',
      showDate: '',
      dataList_hide: [
        { name: '累计交易总金额(元)', date: '****' },
        { name: '累计交易总笔数(笔)', date: '****' },
        { name: '代理商总数(人)', date: '****' },
        { name: '商户总数(人)', date: '****' },
        { name: '终端总数(台)', date: '****' },
        { name: '已激活终端总数(台)', date: '****' },
      ],
      dataList_show: [
        { name: '累计交易总金额(元)', date: '140000.00' },
        { name: '累计交易总笔数(笔)', date: '6' },
        { name: '代理商总数(人)', date: '80' },
        { name: '商户总数(人)', date: '2' },
        { name: '终端总数(台)', date: '10' },
        { name: '已激活终端总数(台)', date: '1' },
      ],
      table1: [],
      table2: {
        row1: {
          name: '任务达标人数-销售政策1',
          detail: [
            { name: '第一阶段', count: 10 },
            { name: '第二阶段', count: 6 },
          ],
        },
        row2: {
          name: '任务达标人数-销售政策2',
          detail: [
            { name: '第一阶段', count: 12 },
            { name: '第二阶段', count: 9 },
            { name: '第二阶段', count: 5 },
          ],
        },
      },
      isSpecial: false,
    };
  },
  watch: {
    actived(val) {
      // 判断当前组件是否被激活
      if (this.flag === val) {
        // 获取状态筛选列表数据项
        this.getUserStatus();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      // 判断当前组件是否被激活
      if (this.flag === this.actived) {
        // 获取状态筛选列表数据项
        this.getUserStatus();
      }
    });
  },
  methods: {
    initNowDate() {
      const pp = PUBLIC_PRODUCT.toLowerCase().trim();
      if (pp === 'cxyf' || pp === 'cxyfzs') {
        const now = new Date();
        this.showDate = now.getFullYear() + '年' + (now.getMonth() + 1) + '月';
      }
    },
    getUserStatus() {
      if (this.$store.state.INTERFACE_ON_OFF === 'off') return;
      Indicator.open();
      GetUserStatus()
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            const mobile = res.data.mobile;
            for (let i = 0; i < PUBLIC_SPECIAL_MOBILE.length; i++) {
              if (PUBLIC_SPECIAL_MOBILE[i] === mobile) {
                this.isSpecial = true;
                break;
              }
            }
            this.initNowDate();
            this.hideFlag = 'hide';
            this.imgEyePath = 'hide_money';
            this.listRebuild();
            this.dataRebuild(this.dataList_hide);
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
          this.listRebuild();
          this.dataRebuild(this.dataList_hide);
        });
    },
    getTradeCount(flag, callBack = null) {
      Indicator.open();
      GetTradeCount({ flag })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.dataRebuild(res.data.date);
            this.table2 = res.data.saleTpls;
            callBack && callBack();
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    listRebuild() {
      this.dataList_hide = [];
      let lblStr = PUBLIC_OVER_LABEL[this.flag];
      // 替换逗号
      lblStr = lblStr.replace(/，/g, ',');
      // 去掉首尾逗号
      lblStr.indexOf(',') === 0 && (lblStr = lblStr.substring(1));
      lblStr.lastIndexOf(',') === lblStr.length - 1 && (lblStr = lblStr.substring(0, lblStr.length - 1));
      const lblArr = lblStr.split(',');
      lblArr.forEach(str => {
        const obj = { name: str, date: '****' };
        this.dataList_hide.push(obj);
      });
    },
    dataRebuild(data) {
      const len = data.length;
      const n = 2;
      const lineNum = len % n === 0 ? len / n : Math.floor(len / n + 1);
      this.table1 = [];
      for (let i = 0; i < lineNum; i++) {
        const obj = data.slice(i * n, i * n + n);
        if (this.isSpecial) {
          if (
            obj[0].name !== '团队总人数(人)' &&
            obj[0].name !== '直推伙伴(人)' &&
            obj[0].name !== '有效商户数(人)' &&
            obj[0].name !== '商户总数(人)' &&
            obj[0].name !== '代理总数(人)' &&
            obj[0].name !== '直推商户总数(人)' &&
            obj[0].name !== '直推有效商户数(人)' &&
            obj[0].name !== '直推代理总数(人)'
          ) {
            this.table1.push(JSON.parse(JSON.stringify(obj)));
          }
        } else {
          this.table1.push(JSON.parse(JSON.stringify(obj)));
        }
      }
    },
    changeDisplayHandler() {
      if (this.hideFlag === 'hide') {
        switch (this.$store.state.INTERFACE_ON_OFF) {
          case 'on':
            this.getTradeCount(this.flag, () => {
              this.imgEyePath = 'show_money';
              this.hideFlag = 'show';
            });
            break;
          case 'off':
            this.dataRebuild(this.dataList_show);
            this.imgEyePath = 'show_money';
            this.hideFlag = 'show';
            break;
        }
      } else if (this.hideFlag === 'show') {
        this.dataRebuild(this.dataList_hide);
        this.imgEyePath = 'hide_money';
        this.hideFlag = 'hide';
      }
    },
  },
  filters: {
    shortText(val) {
      if (val.length > 12) return val.substring(0, 12) + '…';
      return val;
    },
  },
};
</script>
